import { render } from "./Form.vue?vue&type=template&id=35441c1c&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=35441c1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35441c1c"

export default script